// extracted by mini-css-extract-plugin
export default {"spoilerBlock":"Spoiler_spoilerBlock__S9Mlt","spoilerBtn":"Spoiler_spoilerBtn__3sAMC","expanded":"Spoiler_expanded__IWaDm"};